import React, {useState, useEffect, useContext, useRef} from 'react'
import UserContext from '../../context/context'
import styled from 'styled-components';
// import { Link } from 'react-router-dom';
// import { history } from '../../_helpers';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';

import {TableApp} from './Table'
import {SelectColumnFilter} from './Table'
import {fieldOptions, SMfieldOptions, ITfieldOptions, BMfieldOptions, SMjobOptions, ITjobOptions, BMjobOptions,freshOptionsWithNull } from '../SignIn/data';



function ComSearch(){
  const [state, actions] = useContext(UserContext);
  const [userlist, setUserlist] = useState(null)
  const [filter, setFilter] = useState()

  const [ra, setRa] = useState()
  
  const history = useHistory()

  const [divnum, setDivnum] = useState("default")

  const [currentField, setCurrentField] = useState()

  const [currentJob, setCurrentJob] = useState()

  const [whichjobOptions, setWhichjobOptions] = useState()
  const [optionsLen, setOptionsLen] = useState()

  const [transform, setTransform] = useState(0)

  const pagefrom = 0
  const pageto=4

  const [from, setFrom] = useState(pagefrom)
  const [to, setTo] = useState(pageto)

  const [fresh, setFresh] = useState()
  const [isShowing, setIsShowing] = useState(false)
  
  const ref = useRef();
  const observer = useRef();
  const [page, setPage] = useState(1);
  const [end, setEnd] = useState(false)

  const [schoollist, setSchoollist] = useState()
  const [worklist, setWorklist] = useState()
  
  let user = JSON.parse(String(localStorage.getItem('user')))
  
  const header = {Authorization: `JWT ${user.token}`}
  
  // if(localStorage.getItem("is_headhunter") === "true") apilink = "/api/rahh/"
  // else if (localStorage.getItem("is_recruiter") === "true") apilink = "/api/ra/"

  useEffect(()=>{
    let temp_currentField = history.location.pathname.split('/').length < 6 ? 
    history.location.pathname.split('/')[3] ?
    history.location.pathname.split('/')[3]: null : null

    let temp_currentJob = history.location.pathname.split('/').length < 6 ? 
    history.location.pathname.split('/')[4] ?
    history.location.pathname.split('/')[4]: null : null
    
    setCurrentField(history.location.pathname.split('/').length < 6 ? 
    history.location.pathname.split('/')[3] ?
    history.location.pathname.split('/')[3]: null : null)

    setCurrentJob(history.location.pathname.split('/').length < 6 ? 
    history.location.pathname.split('/')[4] ?
    history.location.pathname.split('/')[4]: null : null)
    
    const options = {
      // root: document,
      rootMargin: "20px",
      threshold: 1
    };
    const callback = (entries) => {
      console.log("callback")
      // console.log(entries)
      // console.log(entries[0].isIntersecting)
      if (entries[0].isIntersecting) {
        const newPage = page + 1;
        console.log("fetchagain")
        console.log(from, to)
        fetch(state.awslink + "/user/userlist/"+
          "?from=" + from +
          "&to=" + to +
          "&field="+ temp_currentField + 
          "&job=" + temp_currentJob +
          "&fresh=" + fresh
          , {
          method: 'GET',
          headers: header,
          })
          .then(response => response.json())
          .then(json=>{
            console.log(json)
            if(json){
              if(json["userlist"] && json["userlist"].length){
                setFrom(to)
                setTo(parseInt(to)*2)
                // console.log(JSON.stringify(userlist), JSON.stringify(userlist))
                console.log(JSON.stringify(userlist) === JSON.stringify(userlist))
                if(userlist){
                  if(JSON.stringify(userlist) === JSON.stringify(json["userlist"])){
                    setUserlist(json["userlist"])
                    // setSchoollist(json["schoollist"])
                    // setWorklist(json["worklist"])
                  }
                  else{
                    console.log("CONCAT")
                    // setUserlist(userlist.concat(json))
                    // console.log(json["userlist"], json["schoollist"], json["worklist"])
                    if(json["userlist"]) setUserlist(userlist.concat(json["userlist"]))
                    if(json["schoollist"]) setSchoollist(schoollist.concat(json["schoollist"]))
                    if(json["worklist"]) setWorklist(worklist.concat(json["worklist"]))
                  }
                }
                else
                  setUserlist(json)
              }
              else{
                setEnd(true)
              }
            }
            else{
              setEnd(true)
            }
          })
        setPage(newPage);
      }
    };

    observer.current = new IntersectionObserver(callback, options);

    if (ref.current) {
      console.log(ref.current)
      observer.current.observe(ref.current);
    }

    if(currentField){

      if(SMfieldOptions.filter((item)=>item.value === currentField).length){
        let index = SMfieldOptions.findIndex((item)=>item.value===currentField)
        setWhichjobOptions(SMjobOptions[index])
        setOptionsLen(SMjobOptions[index].length*162)
      }
      else if(ITfieldOptions.filter((item)=>item.value === currentField).length){
        let index = ITfieldOptions.findIndex((item)=>item.value===currentField)
        setWhichjobOptions(ITjobOptions[index])
        setOptionsLen(ITjobOptions[index].length*162)
      }
      else if(BMfieldOptions.filter((item)=>item.value === currentField).length){
        let index = BMfieldOptions.findIndex((item)=>item.value===currentField)
        setWhichjobOptions(BMjobOptions[index])
        setOptionsLen(BMjobOptions[index].length*162)
      }
    }
    else{
      setWhichjobOptions(fieldOptions)
      setOptionsLen(fieldOptions.length*162)
    }

    async function fetchUserlist(){
      console.log("INIT")
      fetch(state.awslink + "/user/userlist/"+
      "?from=" + from +
      "&to=" + to +
      "&field="+ temp_currentField + 
      "&job=" + temp_currentJob +
      "&fresh=" + fresh
      , {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        if(json["userlist"]) setUserlist(json["userlist"])
        if(json["schoollist"]) setSchoollist(json["schoollist"])
        if(json["worklist"]) setWorklist(json["worklist"])
      }
      )
    }

    async function fetchRa(){
      fetch(state.awslink + "/api/ra/", {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        setRa(json)

      }
      )
    }

    async function fetchRaHH(){
      fetch(state.awslink + "/api/rahh/", {
      method: 'GET',
      headers: header,
      })
      .then(response => response.json())
      .then(json=>{
        console.log(json)
        console.log(json["ra"])
        let newobj = [];
        if(json["ra"])
          if(json["ra"].length)
            {json["ra"].map((item, index)=>{
              newobj.push(item)
              return null
            })}
        if(json["ra_shop_hh"])
          if(json["ra_shop_hh"].length)
            {json["ra_shop_hh"].map((item, index)=>{
              newobj.push(item)
              return null
            })}
        if(json["ra_shop_7"])
          if(json["ra_shop_7"].length)
            {json["ra_shop_7"].map((item, index)=>{
              newobj.push(item)
              return null
            })}
        
        setRa(newobj)

      }
      )
    }

    if(!userlist) fetchUserlist()

    return () => {
      observer.current.disconnect();
    };
    
  }, [ref, userlist, schoollist, worklist, currentField, currentJob, history.location.pathname, fresh])

  function initData(){
    setUserlist(); setFrom(pagefrom); setTo(pageto); setEnd(false);
  }
  
  console.log(userlist, schoollist, worklist)
  return(
    <>
    {state.width < state.breakpoint ? 
      null
    :
      <Wrapper>
        <MenuWrapper>
          <div>
            <MenuTitle>
              <li>
                <Link to={'/recruiter/search'} onClick={()=>setUserlist(null)}>전체</Link>
              </li>
              {currentField && <li><Link to={'/recruiter/search/'+currentField} onClick={()=>setUserlist(null)}>{currentField}</Link></li>}
              {currentJob && <li><Link to={'/recruiter/search/' + currentField + '/' + currentJob} onClick={()=>setUserlist(null)}>{currentJob}</Link></li>}
            </MenuTitle>
            
            <Menu>
              {transform !== 0 && <button id={"left"} onClick={()=>{
                if(transform !== 0)
                  setTransform(transform+324)}}>&#60;</button>}
              
              {whichjobOptions && whichjobOptions.map((item, index)=>{
                if(whichjobOptions === fieldOptions)
                return(
                  <li style={{transform : `translateX(${transform}px)`, transition: ".5s"}}>
                    <Link to={'/recruiter/search/'+ item.value} 
                    onClick={()=>{initData(); setCurrentField(item.value)}}>{item.value}</Link>
                  </li>
                )
                else
                return(
                  <li style={{transform : `translateX(${transform}px)`, transition: ".5s"}}>
                    <Link to={'/recruiter/search/'+ currentField + "/" + item.value} 
                    onClick={()=>{initData(); setCurrentField(currentField); setCurrentJob(item.value)}}>{item.value}</Link>
                  </li>
                )
              })}
              {optionsLen > state.breakpoint?
              -transform < optionsLen-window.innerWidth*0.9 && 
              <button id={"right"} onClick={()=>{
                console.log(transform, optionsLen-window.innerWidth*0.9)
                setTransform(transform-324)
              }}>&#62;</button>
            :null}
            </Menu>
            
          </div>
        </MenuWrapper>

        <RaWrapper>
          <Options>
            <Select
              className="ralist-basic-single"
              defaultValue={null}
              placeholder={"경력"}
              isSearchable={true}
              name="color"
              options={freshOptionsWithNull}
              onChange={(e)=>{setFresh(e.value); initData();}}
            />
          </Options>
        
          <CardWrapper>
            {userlist ? 
              userlist.map((item, index)=>{
                // console.log(item.which)
                if(item.id !== user.user["pk"])
                return(
                <Card>
                  <div>
                    <Link to={'/recruiter/singlesearch/'+ item.id + '/' + item.which}> 
                    
                      <div>
                        <div className={"qu-title"}>{item.realname}</div>
                        <div className={"qu-subtitle"}>{item.field? item.field: "없음"}</div>
                        <div className={"qu-subtitle"}>{item.job? item.job: "없음"}</div>
                        {schoollist && schoollist.length? 
                          schoollist.filter(subitem=>subitem.user.id === item.id).map((item, index)=>{
                            return(
                              <>
                                <div className={"qu-subtitle"}>{item.title} - {item.degree}</div>
                              </>
                            )
                          })
                        : null}

                        {worklist && worklist.length? 
                          worklist.filter(subitem=>subitem.user.id === item.id).map((item, index)=>{
                            return(
                              <>
                                <div className={"qu-subtitle"}>{item.title} - {item.depart}</div>
                              </>
                            )
                          })
                        : null}

                        
                      </div>
                    </Link>
                    
                  </div>
                  
                </Card>
                )
              })
              
            :null}
            
          </CardWrapper>
          
          
          
          {userlist && !end ?
          <div ref={ref} style={{ width: "100%", height: "20px" }}>
            Bottom
          </div>
          : null}
          
        </RaWrapper>
        


      </Wrapper>   
      }
    </>
  )
}


const Wrapper = styled.div`
  width: 100%;
  min-height: calc(100vh - 50px);
  margin-top: 0px;
  display: block;
  position: relative;
`

const RaWrapper = styled.div`
  max-width: 1060px;
  width: 90%;
  display: block;
  margin: 0 auto;
  background-color: whitesmoke;
`

const MenuWrapper = styled.div`
  position: relative;
  height: 140px;
  >div{
    max-width: 1060px;
    width: 90%;
    height: 100%;
    margin: 0 auto;

    
  }
`
const MenuTitle = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: left;
  white-space:nowrap;
  >li{
    display: inline-block;
    padding: 5px;
    >a{
      text-decoration: none;
      color: black;
    }
  }
  .ralist-basic-single{
    width: 100px;
  }
`

const Options = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  padding-top: 10px;
  padding-bottom: 10px;
  text-align: left;
  white-space:nowrap;
  display: flex;
  
  align-items: center;
  >div{
    display: inline-block;
    margin-right: 10px;
    
  }
  .tag-btn{
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      background-color: hsl(0, 0%, 100%);
      border-color: hsl(0, 0%, 80%);
      border-radius: 4px;
      border-style: solid;
      border-width: 1px;
      height: 36px;
      width: 100px;

      display: flex;
      align-items: center;
      flex-wrap: nowrap;
      >div{
        cursor: pointer;
        height: 100%;
        display:flex;
        justify-content: center;
        align-items: center;
        :first-child{
          color: hsl(0, 0%, 50%);
          width: 40%;
          border-right: 1px hsl(0, 0%, 80%) solid;
        }
        :last-child{
          width: 60%;
          
        }
      }
    }
  .ralist-basic-single{
    width: 100px;
  }
`
const Menu = styled.ul`
  margin: 0;
  padding: 0;
  height: 52px;
  list-style:none;
  white-space:nowrap;
  overflow: hidden;
  text-align: left;
  position: relative;
  
  >li{
    
    display: inline-block;
    width: 150px;
    border: .5px solid black;
    height: 50px;
    z-index: 2;
    margin-right: 10px;
    >a{
      background-color: rgba(0,0,0,0.6);
      color: whitesmoke;
      text-decoration: none;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

  }

  #left{
    position: absolute;
    height: 52px;
    width: 100px;
    border: none;
    left: 0;
    z-index: 3;
    
    color: rgba(255,255,255,0.8);
    background: linear-gradient(to left, transparent, 60%, black);
    font-size: 2rem;
    text-align: left;
    cursor: pointer;
    opacity: 0.8;
    transition: .2s;
    :hover{
      opacity: 1;
    }
  }
  #right{
    position: absolute;
    height: 52px;
    width: 100px;
    border: none;
    right: 0;
    z-index: 3;
    
    color: rgba(255,255,255,0.8);
    background: linear-gradient(to right, transparent, 60%, black);
    font-size: 2rem;
    text-align: right;
    cursor: pointer;
    opacity: 0.8;
    transition: .2s;
    :hover{
      opacity: 1;
    }
  }
  

`

const RecCardWrapper = styled.ul`
  margin: 0;
  padding: 0;
  /* height: 52px; */
  list-style:none;
  /* white-space:nowrap; */
  /* overflow: hidden; */
  /* text-align: left; */
  /* margin: -10px; */
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  margin: 0 -10px 40px;

  @media (max-width: 768px){
      overflow:auto;
      /* width: auto; */
      white-space: nowrap;
    }

  >li{
    display: inline-block;
    vertical-align: top;
    width: calc(20% - 20px);
    /* float:left; */
    @media (max-width: 768px){
      width: 35%;
      /* float:none; */
    }
    /* min-width: 140px; */
    height: 220px;
    /* padding: 10px; */
    /* border: .5px solid black; */
    z-index: 2;
    box-sizing: border-box;
    margin: 0 10px;
    
    >div{
      width: 100%;
      height: 100%;
      background-color: rgba(255, 255, 255, 0.8);
      border-radius: 5px;
      >a{
        display: block;
        
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;

        text-decoration: none;
        
        >div{
          cursor: pointer;
          color: black;
          padding: 10px;
          
          >div{
            text-align: left;
          }
        }
        .logo{
          height: 60%;
          display: flex;
          justify-content: center;
          align-items: center;
          >img{
            /* height: 60%; */
            width: 100%;
            background-position-x:50%;
            background-position-y:50%;
            background-size: cover;
            
          }
        }
      }

    }

  }

`

const CardWrapper = styled.ul`
  padding: 0;
  content: " ";
  display: table;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  list-style: none;
  list-style-position: outside;
  /* width: 100%; */
  margin: -10px;
  width: calc(100% + 20px);
`

const Card = styled.li`
  width: 25%;
  box-sizing: border-box;
  -moz-box-sizing: border-box;
  display: inline-block;
  /* padding-bottom: 56.25%; */
  height: calc(25vw * 1.2);
  min-height: 240px;
  max-height: 350px;
  padding: 10px;
  float: left;
  vertical-align: top;
  
  @media (max-width: 768px){
    width: 50%;
  }

  >div{
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.8);
    border-radius: 5px;
    >a{
      display: block;
      
      margin: 0;
      padding: 0;
      width: 100%;
      height: 100%;

      text-decoration: none;
      
      >div{
        cursor: pointer;
        color: black;
        padding: 10px;
        box-sizing: border-box;
        
        >div{
          text-align: left;
        }
      }
      .main{
        height: 60%;
        display: flex;
        padding: 0px;
        justify-content: center;
        align-items: center;
        overflow: hidden;
        >img{
          /* height: 60%; */
          height: 100%;
          background-position-x:50%;
          background-position-y:50%;
          background-size: cover;
          
        }
      }
    }
  }
  
`
export default ComSearch